import React, { useState } from 'react';
import { useFragment, graphql } from 'react-relay';
import type { main_softwareCodePage_ConnectionPage$key } from '@atlassian/jira-relay/src/__generated__/main_softwareCodePage_ConnectionPage.graphql';
import {
	ViewCodePageExperienceSuccessTracker,
	VIEW_CONNECTION_PAGE_EXPERIENCE_NAME,
} from '../../../services/experience-tracker';
import OneClickConnect from './one-click-connect';
import ReadyToConnect from './ready-to-connect';

type ConnectionPageProps = {
	connectionPageData: main_softwareCodePage_ConnectionPage$key;
	isAdmin: boolean;
	onRefetch: () => void;
};

export const ConnectionPage = ({ connectionPageData, isAdmin, onRefetch }: ConnectionPageProps) => {
	const data = useFragment(
		graphql`
			fragment main_softwareCodePage_ConnectionPage on Query {
				...main_softwareCodePage_ReadyToConnect
				...main_softwareCodePage_OneClickConnect
			}
		`,
		connectionPageData,
	);
	const [renderOneClickConnect, setRenderOneClickConnect] = useState(false);

	return (
		<>
			{renderOneClickConnect ? (
				<OneClickConnect
					oneClickConnectData={data}
					onExitOnClickConnectFlow={() => setRenderOneClickConnect(false)}
					onRefetch={onRefetch}
				/>
			) : (
				<ReadyToConnect
					readyToConnectData={data}
					isAdmin={isAdmin}
					onShowOneClickConnect={() => setRenderOneClickConnect(true)}
					onRefetch={onRefetch}
				/>
			)}
			<ViewCodePageExperienceSuccessTracker experienceName={VIEW_CONNECTION_PAGE_EXPERIENCE_NAME} />
		</>
	);
};
